import { Injectable } from '@angular/core';
import { PaginatedResult } from 'src/app/shared/grid/paginate.model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPaginatedServiceParamters } from '../core/models/ITable';
import { Owner } from '../core/models/Owner';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class OwnerService {
  constructor(private apiService: ApiService) {}

  getAllPaginated(
    paginatedArguments: IPaginatedServiceParamters,
  ): Observable<PaginatedResult<Owner[]>> {
    return this.apiService.getPaginated(
      '/api/owner/getallowners',
      paginatedArguments,
    );
  }

  searchOwners(
    query?,
    page?,
    itemsPerPage?,
  ): Observable<PaginatedResult<Owner[]>> {
    var paginatedArguments: IPaginatedServiceParamters = {
      pageNumber: page,
      pageSize: itemsPerPage,
      query: query || '',
    };
    // Permitir búsqueda vacía para cargar opciones iniciales
    return this.apiService.getPaginated('/api/Owner', paginatedArguments);
  }

  getOwner(Id) {
    return this.apiService.get(`/api/Owner/${Id}`);
  }

  deleteOwner(id) {
    return this.apiService.delete(`/api/owner/${id}`);
  }

  updateOwner(id, updateOwner) {
    return this.apiService.put(`/api/owner/${id}`, updateOwner);
  }

  createOwner(newOwner) {
    return this.apiService.post(`/api/owner`, newOwner);
  }

  // Obtiene o genera un link único para el owner
  getOrGenerateUniqueLink(id: number): Observable<string> {
    return this.apiService.get<{ link: string }>(`/api/Owner/${id}/UniqueLink`).pipe(
      map(response => response.link)
    );
  }

  // Obtiene solo el link existente del owner (no genera uno nuevo)
  getUniqueLinkGuid(id: number): Observable<string | null> {
    return this.apiService.get<{ link: string | null }>(`/api/Owner/${id}/UniqueLink/Guid`).pipe(
      map(response => response.link)
    );
  }

  sendPortalInvitation(id: number): Observable<string> {
    return this.apiService.post<{ email: string }>(`/api/Owner/${id}/SendPortalInvitation`, {}).pipe(
      map(response => response.email)
    );
  }
}
